import { render, staticRenderFns } from "./ListMobileCard.vue?vue&type=template&id=5095ed9c&scoped=true"
import script from "./ListMobileCard.vue?vue&type=script&lang=js"
export * from "./ListMobileCard.vue?vue&type=script&lang=js"
import style0 from "./ListMobileCard.vue?vue&type=style&index=0&id=5095ed9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095ed9c",
  null
  
)

export default component.exports